"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../../icons");
const use_combined_refs_1 = __importDefault(require("../utils/use-combined-refs"));
const input_1 = __importDefault(require("./input"));
exports.PasswordInput = react_1.default.forwardRef(function PasswordInput(props, ref) {
    const [type, toggleType] = (0, react_1.useReducer)(state => (state === "text" ? "password" : "text"), "password");
    const innerRef = (0, react_1.useRef)(ref);
    const combinedRef = (0, use_combined_refs_1.default)(ref, innerRef);
    function handleIconAction() {
        var _a;
        toggleType();
        (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    const icon = (props) => react_1.default.createElement(icons_1.ActionIcon, { active: true, icon: type === "text" ? icons_1.EyeOffIcon : icons_1.EyeIcon, onAction: handleIconAction, ...props });
    return react_1.default.createElement(input_1.default, { ref: combinedRef, ...props, rightIcon: icon, type: type });
});
exports.default = exports.PasswordInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFzc3dvcmQtaW5wdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2lucHV0L3Bhc3N3b3JkLWlucHV0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUFrRDtBQUVsRCx1Q0FBeUU7QUFDekUsbUZBQXlEO0FBQ3pELG9EQUE0QztBQUUvQixRQUFBLGFBQWEsR0FBRyxlQUFLLENBQUMsVUFBVSxDQUErQixTQUFTLGFBQWEsQ0FBQyxLQUFpQixFQUFFLEdBQUc7SUFDdkgsTUFBTSxDQUFDLElBQUksRUFBRSxVQUFVLENBQUMsR0FBRyxJQUFBLGtCQUFVLEVBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssS0FBSyxNQUFNLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLEVBQUUsVUFBVSxDQUFDLENBQUM7SUFDckcsTUFBTSxRQUFRLEdBQUcsSUFBQSxjQUFNLEVBQU0sR0FBRyxDQUFDLENBQUM7SUFDbEMsTUFBTSxXQUFXLEdBQUcsSUFBQSwyQkFBZSxFQUFDLEdBQVUsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUUxRCxTQUFTLGdCQUFnQjs7UUFDdkIsVUFBVSxFQUFFLENBQUM7UUFDYixNQUFBLFFBQVEsQ0FBQyxPQUFPLDBDQUFFLEtBQUssRUFBRSxDQUFDO0lBQzVCLENBQUM7SUFFRCxNQUFNLElBQUksR0FBRyxDQUFDLEtBQWdCLEVBQUUsRUFBRSxDQUFDLDhCQUFDLGtCQUFVLElBQUMsTUFBTSxRQUFDLElBQUksRUFBRSxJQUFJLEtBQUssTUFBTSxDQUFDLENBQUMsQ0FBQyxrQkFBVSxDQUFDLENBQUMsQ0FBQyxlQUFPLEVBQUUsUUFBUSxFQUFFLGdCQUFnQixLQUFNLEtBQUssR0FBSSxDQUFDO0lBRTlJLE9BQU8sOEJBQUMsZUFBSyxJQUFDLEdBQUcsRUFBRSxXQUFXLEtBQU0sS0FBSyxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksR0FBSSxDQUFDO0FBQzdFLENBQUMsQ0FBQyxDQUFDO0FBRUgsa0JBQWUscUJBQWEsQ0FBQyJ9